export enum AcTypeEnum {
  ACFull = 'AC Pełne',
  ACMini = 'AC Mini',
}
